import type { GetIssueByIdResponseRow } from '@risksmart-app/trpc/src/types';
import type { GetIssueByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetIssueByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createLazyQueryHook } from 'src/utils';

type UseLazyGetIssueByIdArgs = {
  id: string;
};

export const useLazyGetIssueById = createLazyQueryHook<
  UseLazyGetIssueByIdArgs,
  GetIssueByIdResponseRow[],
  GetIssueByIdQuery
>({
  trpcQuery: (client, { id }) => client.frontend.issue.issueById.query({ id }),
  mapTrpcDataToGraphQL: (data) => ({ issue: data }),
  graphqlDocument: GetIssueByIdDocument,
  graphqlVariables: ({ id }) => ({ _eq: id }),
});
